import { defaultSchema } from '../../functions/validation';
import { formatDate } from '../../functions/textFormatting';

export const requestTypes = {
  NO_LONGER_OWN: "I no longer own this vehicle",
  NEW_OWNER: "I am the new owner of this vehicle",
  PERSONAL_DETAILS_CHANGED: "My personal details have changed",
  WRITTEN_OFF: "This vehicle has been written-off",
};

export const newOwnerTypes = {
  PRIVATE: "Private",
  DEALER: "Non-Audi Dealer",
  AUDI: "Audi Dealer",
};

export const consentLabel = "I consent to being contacted by Audi Australia to verify change of ownership details (If you uncheck this box, we may not be able to process your request)";
export const optinLabel = "I consent to being contacted by Audi Australia and Audi Dealers with occasional communications on products, offers, news and events.";

export const validationSchema = {
    requestType: {
        presence: {message: "Please choose a request type", allowEmpty: false}
    },
    vin: function(value, attributes, attributeName, options, constraints) {
        if (value?.length > 0) {
            return defaultSchema.vin;
        } else if (!attributes.rego) {
            return {presence: { message: "Please enter your VIN or registration", allowEmpty: false }};
        }
        return;
    },
    regoState: function(value, attributes, attributeName, options, constraints) {
        if (!attributes.vin && attributes.rego?.length > 0) {
            return {presence: { message: "Please select your registration state", allowEmpty: false }};
        }
        return;
    },
    firstName: defaultSchema.firstName,
    lastName: defaultSchema.lastName,
    email: defaultSchema.emailAddress,
    phone: defaultSchema.phoneNumber,
    address: { presence: {message: "Please enter your address", allowEmpty: false} },
    suburb: { presence: {message: "Please enter your suburb", allowEmpty: false} },
    postCode: defaultSchema.postCode,
    changedName: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
            return { presence: {message: "Please select an option", allowEmpty: false} };
        }
        return;
    },
    changedPhone: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
            return { presence: {message: "Please select an option", allowEmpty: false} };
        }
        return;
    },
    changedEmail: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
            return { presence: {message: "Please select an option", allowEmpty: false} };
        }
        return;
    },
    changedAddress: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
            return { presence: {message: "Please select an option", allowEmpty: false} };
        }
        return;
    },
    newOwnerType: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.NO_LONGER_OWN) {
            return { presence: {message: "This field is required", allowEmpty: false} };
        }
        return;
    },
    dealerName: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.NO_LONGER_OWN && attributes.newOwnerType === newOwnerTypes.AUDI) {
            return { presence: {message: "This field is required", allowEmpty: false} };
        }
        return;
    },
    dateOfChange: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.NO_LONGER_OWN || attributes.requestType === requestTypes.NEW_OWNER) {
            return { presence: {message: "Please enter the date of sale", allowEmpty: false} };
        } else if (attributes.requestType === requestTypes.WRITTEN_OFF) {
            return { presence: {message: "Please enter the write-off date", allowEmpty: false} };
        }
        return;
    },
    files1: function(value, attributes, attributeName, options, constraints) {
        if (attributes.requestType === requestTypes.NEW_OWNER || attributes.requestType === requestTypes.WRITTEN_OFF) {
            return { isFile: {message: "A supporting document is required"} };
        }
        return;
    },
    consent: {
        truthy: {message: "Please select the checkbox to give your consent before proceeding"}
    },
};

export const initialValues = {
    vin: "",
    rego: "",
    regoState: "",
    requestType: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    suburb: "",
    postCode: "",
    newOwnerType: "",
    newOwnerName: "",
    newOwnerLName: "",
    newOwnerEmail: "",
    newOwnerPhone: "",
    newOwnerAddress: "",
    newOwnerSuburb: "",
    newOwnerPostcode: "",
    dateOfChange: null,
    consent: false,
    optIn: false,
    files1: null,
    files2: null,
    notUsingMyaudi: false,
    changedName: "",
    changedPhone: "",
    changedEmail: "",
    changedAddress: "",
};

export const mapValues = (formData) => {
    var _data = {
        'VIN': formData.vin,
        'Registration': formData.rego,
        'State': formData.regoState,
        'Request type': formData.requestType,
        'consent': formData.consent,
        'optIn': formData.optIn,
        'optOut': !formData.optIn,
    };
    var user = {
        'First name': formData.firstName,
        'Last name': formData.lastName,
        'Email': formData.email,
        'Contact number': formData.phone,
        'Address': formData.address,
        'Suburb': formData.suburb,
        'Postcode': formData.postCode
    };
    if (formData.requestType === requestTypes.NEW_OWNER) {
        _data['New owner details'] = user;
    } else if (formData.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
        user['Changed name'] = formData.changedName;
        user['Changed phone'] = formData.changedPhone;
        user['Changed email'] = formData.changedEmail;
        user['Changed address'] = formData.changedAddress;
        _data['New personal details'] = user;
    } else {
        _data['Your details'] = user;
    }
    if (formData.requestType === requestTypes.NO_LONGER_OWN) {
        _data['New owner details'] = {
            'Type': formData.newOwnerType,
            'Name': formData.newOwnerType === newOwnerTypes.AUDI ? formData.dealerName : formData.newOwnerName,
            'Last name': formData.newOwnerType === newOwnerTypes.PRIVATE ? formData.newOwnerLName : "",
            'Email': formData.newOwnerType === newOwnerTypes.AUDI ? "" : formData.newOwnerEmail,
            'Contact number': formData.newOwnerType === newOwnerTypes.AUDI ? "" : formData.newOwnerPhone,
            'Address': formData.newOwnerType === newOwnerTypes.PRIVATE ? formData.newOwnerAddress : "",
            'Suburb': formData.newOwnerType === newOwnerTypes.PRIVATE ? formData.newOwnerSuburb : "",
            'Postcode': formData.newOwnerType === newOwnerTypes.PRIVATE ? formData.newOwnerPostcode : "",
        };
    }
    if (formData.requestType === requestTypes.NO_LONGER_OWN || formData.requestType === requestTypes.NEW_OWNER) {
        _data['Date of sale'] = formatDate(formData.dateOfChange);
    }
    if (formData.requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
        _data['Date of change'] = formatDate(formData.dateOfChange);
    }
    if (formData.requestType === requestTypes.WRITTEN_OFF) {
        _data['Write-off date'] = formatDate(formData.dateOfChange);
    }
    return _data;
}

export const mapApiErrors = (modelState) => {
    // all: vin, consent
    // no longer own: prev_owner_phone, prev_owner_email, new_owner_phone, new_owner_email
    // details changed: personal_phone, personal_email
    const keyMap = {
        prev_owner_phone: "phone",
        prev_owner_email: "email",
        new_owner_phone: "newOwnerPhone",
        new_owner_email: "newOwnerEmail",
        personal_phone: "phone",
        personal_email: "email"
    };
    let errors = {};
    for (let key in modelState) {
        if (!Object.hasOwnProperty(key)) {
            let newKey = keyMap[key] || key;
            errors[newKey] = modelState[key][0];
        }
    }
    return errors;
}
